import { formatScoreValue } from '../../utils/utils'

import { CardDashboard, Flex, Typography } from '@percent/lemonade'
import { AggregateScoresProps } from './AggregateScores.types'

export function AggregateScores({ scores }: Readonly<AggregateScoresProps>) {
  if (scores.length === 0) {
    return null
  }

  return (
    <Flex gap={16} mb={16} wrap="nowrap" data-testid="aggregate-scores">
      {scores.map((score, index) => (
        <Flex
          flex={1}
          miw={0}
          // eslint-disable-next-line react/no-array-index-key
          key={`aggregate-score-${index}`}
        >
          <CardDashboard data-testid={`aggregate-score-${index}`} style={{ width: '100%' }}>
            <Flex direction="column" gap={8}>
              <Typography variant="default-medium">{score.name}</Typography>
              <Typography variant="large">{formatScoreValue(score.value)}</Typography>
            </Flex>
          </CardDashboard>
        </Flex>
      ))}
    </Flex>
  )
}
